// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.bs.js");
var MM_syntax_tree = require("../mm-utils/MM_syntax_tree.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Select = require("@mui/material/Select").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;
var FormControl = require("@mui/material/FormControl").default;

function rndIconButton(icon, onClick, active, title, param) {
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

function makeInitialState(param) {
  return {
          newText: "",
          infoExpanded: false
        };
}

function setNewText(st, text) {
  return {
          newText: text,
          infoExpanded: st.infoExpanded
        };
}

function setInfoExpanded(st, infoExpanded) {
  return {
          newText: st.newText,
          infoExpanded: infoExpanded
        };
}

function leftClickHnd(mouseEvt, clbk, ifNot) {
  if (mouseEvt.button === 0) {
    return Curry._1(clbk, undefined);
  } else {
    return Curry._1(ifNot, mouseEvt);
  }
}

function altLeftClickHnd(mouseEvt, clbk, ifNot) {
  if (mouseEvt.button === 0 && mouseEvt.altKey) {
    return Curry._1(clbk, undefined);
  } else {
    return Curry._1(ifNot, mouseEvt);
  }
}

function MM_cmp_user_stmt(Props) {
  var stmt = Props.stmt;
  var onLabelEditRequested = Props.onLabelEditRequested;
  var onLabelEditDone = Props.onLabelEditDone;
  var onTypEditRequested = Props.onTypEditRequested;
  var onTypEditDone = Props.onTypEditDone;
  var onContEditRequested = Props.onContEditRequested;
  var onContEditDone = Props.onContEditDone;
  var onJstfEditRequested = Props.onJstfEditRequested;
  var onJstfEditDone = Props.onJstfEditDone;
  var onGenerateProof = Props.onGenerateProof;
  var match = React.useState(function () {
        return {
                newText: "",
                infoExpanded: false
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (stmt.labelEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.label);
                  }));
          } else if (stmt.typEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.typ);
                  }));
          } else if (stmt.contEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, MM_wrk_editor.contToStr(stmt.cont));
                  }));
          } else if (stmt.jstfEditMode) {
            Curry._1(setState, (function (__x) {
                    return setNewText(__x, stmt.jstfText);
                  }));
          }
          
        }), [
        stmt.labelEditMode,
        stmt.typEditMode,
        stmt.contEditMode,
        stmt.jstfEditMode
      ]);
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return setNewText(__x, newText);
          }));
  };
  var actLabelEditDone = function (param) {
    Curry._1(onLabelEditDone, state.newText);
  };
  var actTypEditDone = function (newTypStr) {
    Curry._1(onTypEditDone, MM_wrk_editor.userStmtTypeFromStr(newTypStr));
  };
  var actContEditDone = function (param) {
    Curry._1(onContEditDone, MM_wrk_editor.strToCont(state.newText));
  };
  var actJstfEditDone = function (param) {
    Curry._1(setState, (function (st) {
            return setInfoExpanded(st, true);
          }));
    Curry._1(onJstfEditDone, state.newText);
  };
  var ctrlEnterHnd = function (kbrdEvt, clbk) {
    if (kbrdEvt.ctrlKey && kbrdEvt.keyCode === 13) {
      return Curry._1(clbk, undefined);
    }
    
  };
  var rndLabel = function (param) {
    if (stmt.labelEditMode) {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(TextField, {
                      value: state.newText,
                      size: "small",
                      style: {
                        width: "100px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actNewTextUpdated, param);
                        }),
                      onKeyDown: (function (__x) {
                          ctrlEnterHnd(__x, actLabelEditDone);
                        }),
                      autoFocus: true,
                      title: "Ctrl+Enter to save"
                    }), rndIconButton(React.createElement(Save, {}), actLabelEditDone, state.newText.trim() !== "", "Save, Ctrl+Enter", undefined));
    } else {
      return React.createElement("span", {
                  title: "<left-click> to change",
                  onClick: (function (__x) {
                      leftClickHnd(__x, onLabelEditRequested, (function (param) {
                              
                            }));
                    })
                }, stmt.label);
    }
  };
  var rndCont = function (param) {
    if (stmt.contEditMode) {
      return React.createElement(Expln_React_Row.make, {
                  children: null
                }, React.createElement(TextField, {
                      value: state.newText,
                      size: "small",
                      style: {
                        width: "600px"
                      },
                      multiline: true,
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actNewTextUpdated, param);
                        }),
                      onKeyDown: (function (__x) {
                          ctrlEnterHnd(__x, actContEditDone);
                        }),
                      autoFocus: true,
                      title: "Ctrl+Enter to save"
                    }), rndIconButton(React.createElement(Save, {}), actContEditDone, state.newText.trim() !== "", "Save, Ctrl+Enter", undefined));
    }
    var arr = stmt.cont;
    var tmp;
    tmp = arr.TAG === /* Text */0 ? arr._0.join(" ") : MM_syntax_tree.syntaxTreeToSymbols(arr._0).join(" ");
    return React.createElement(Paper, {
                onClick: (function (__x) {
                    leftClickHnd(__x, onContEditRequested, (function (param) {
                            
                          }));
                  }),
                style: {
                  backgroundColor: "rgb(255,255,235)",
                  padding: "1px 10px"
                },
                title: "<left-click> to change",
                children: tmp
              });
  };
  var rndProofStatus = function (param) {
    var status = stmt.proofStatus;
    if (status !== undefined) {
      if (status === "ready") {
        return React.createElement("span", {
                    style: {
                      color: "green",
                      cursor: "pointer",
                      fontWeight: "bold"
                    },
                    title: "Proof is ready, left-click to generate compressed proof",
                    onClick: (function (param) {
                        Curry._1(onGenerateProof, undefined);
                      })
                  }, "\u2713");
      } else if (status === "noJstf") {
        return React.createElement("span", {
                    style: {
                      color: "red",
                      fontWeight: "bold"
                    },
                    title: "Justification cannot be determined automatically"
                  }, "?");
      } else if (status === "jstfIsIncorrect") {
        return React.createElement("span", {
                    style: {
                      color: "red",
                      fontWeight: "bold"
                    },
                    title: "Justification is incorrect"
                  }, "\u2717");
      } else {
        return React.createElement("span", {
                    style: {
                      color: "orange",
                      fontWeight: "bold"
                    },
                    title: "Justification for this statement is correct"
                  }, "\u223F");
      }
    } else {
      return null;
    }
  };
  var rndTyp = function (param) {
    if (stmt.typEditMode) {
      return React.createElement(FormControl, {
                  size: "small",
                  children: React.createElement(Select, {
                        value: "",
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actTypEditDone, param);
                          }),
                        children: null
                      }, React.createElement(MenuItem, {
                            value: "e",
                            children: "H"
                          }), React.createElement(MenuItem, {
                            value: "p",
                            children: "P"
                          }))
                });
    }
    var match = stmt.typ;
    var typStr = match === "p" ? "P" : "H";
    return React.createElement("span", {
                style: {
                  cursor: "pointer",
                  fontWeight: "bold"
                },
                title: "Alt+<left-click> to change statement type. Left-click to show/hide the justification for provable.",
                onClick: (function (__x) {
                    altLeftClickHnd(__x, onTypEditRequested, (function (param) {
                            Curry._1(setState, (function (st) {
                                    return setInfoExpanded(st, !st.infoExpanded);
                                  }));
                          }));
                  })
              }, typStr.toUpperCase());
  };
  var rndInfoBody = function (param) {
    if (stmt.typ === "p" && (state.infoExpanded || stmt.jstfEditMode)) {
      if (stmt.jstfEditMode) {
        return React.createElement(Expln_React_Row.make, {
                    children: null
                  }, React.createElement(TextField, {
                        value: state.newText,
                        label: "Justification",
                        size: "small",
                        style: {
                          width: "600px"
                        },
                        multiline: true,
                        onChange: (function (param) {
                            return Expln_React_common.evt2str(actNewTextUpdated, param);
                          }),
                        onKeyDown: (function (__x) {
                            ctrlEnterHnd(__x, actJstfEditDone);
                          }),
                        autoFocus: true,
                        title: "Ctrl+Enter to save"
                      }), rndIconButton(React.createElement(Save, {}), actJstfEditDone, true, "Save, Ctrl+Enter", undefined));
      } else {
        return React.createElement(Paper, {
                    onClick: (function (__x) {
                        leftClickHnd(__x, onJstfEditRequested, (function (param) {
                                
                              }));
                      }),
                    style: {
                      padding: "3px"
                    },
                    title: "<left-click> to change",
                    children: null
                  }, "Justification: ", stmt.jstfText);
      }
    } else {
      return null;
    }
  };
  return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndProofStatus(undefined)), React.createElement("td", undefined, rndLabel(undefined)), React.createElement("td", undefined, rndTyp(undefined)), React.createElement("td", undefined, rndCont(undefined))), React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndInfoBody(undefined)))));
}

var make = MM_cmp_user_stmt;

exports.rndIconButton = rndIconButton;
exports.makeInitialState = makeInitialState;
exports.setNewText = setNewText;
exports.setInfoExpanded = setInfoExpanded;
exports.leftClickHnd = leftClickHnd;
exports.altLeftClickHnd = altLeftClickHnd;
exports.make = make;
/* react Not a pure module */
